import React from 'react';
import { AdvanceDirectiveTypeOptions, getAdvanceDirectivesOptions } from '@generated';
import { NoItemsFound } from '~/shared/components/NoItemsFound';
import { useSuspenseQuery } from '@tanstack/react-query';
import { AdvanceDirectivesTable } from './AdvanceDirectivesTable';
import { QuickAddNew } from '~/shared/QuickAdd';
import { AdvanceDirectiveFormModal } from './forms/AdvanceDirectiveFormModal';

export function AdvanceDirectives({ stayId }: { stayId: string }) {
	const { data: advanceDirectives } = useSuspenseQuery(getAdvanceDirectivesOptions(stayId));
	const [selectedQuickAddId, setSelectedQuickAddId] = React.useState<number | null>(null);

	return (
		<div className="space-y-8">
			<div className="col-span-3 mb-4 flex flex-wrap items-center">
				<QuickAddNew
					options={AdvanceDirectiveTypeOptions.filter(
						x => x.displayForQuickAccess && !advanceDirectives.directives.find(y => y.advanceDirectiveTypeId === x.id)
					).map(x => ({ id: x.id, label: x.abbreviation }))}
					onSelect={val => setSelectedQuickAddId(val.id)}
				/>
			</div>
			<NoItemsFound
				title="No directives recorded"
				subtitle="Click the button below to add a directive"
				itemCount={advanceDirectives.directives.length}
				renderModal={closeModal => <AdvanceDirectiveFormModal stayId={stayId} closeModal={closeModal} />}
				renderTable={() => <AdvanceDirectivesTable rows={advanceDirectives.directives} />}
			/>
			{selectedQuickAddId && (
				<AdvanceDirectiveFormModal
					stayId={stayId}
					quickAddAdvancedDirectiveTypeId={selectedQuickAddId}
					closeModal={() => setSelectedQuickAddId(null)}
				/>
			)}
		</div>
	);
}
